<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Add Milestone</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="close()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">Add milestone for <b>{{data.displayName}}</b></div>
        </div>
    </div>
</div>

<div class="modal-body custom-material-form modal-p2p-padding" [formGroup]="form"> 
    <div class="row justify-content-center">
        <div class="col-12">
            <mdb-form-control class="form-fill form-outline">
                <app-mdbp-input mdbInput formControlName="eventCount" label='Enter milestone count' type="number" [showMaxLength]="false"></app-mdbp-input>
                @if(form.controls.eventCount.invalid && form.controls.eventCount.touched) {
                    <span class="form-fill-error ml-0">{{eventCountErrorText}}</span>
                }
            </mdb-form-control> 
        </div>
    </div>
</div>

<div class="modal-footer paybee-modal-footer">
    <a (click)="close()" class="btn btn-sm modal-cancel-button waves-effect waves-light">Cancel</a>
    <a (click)="addMilestone()" class="btn btn-sm modal-confirm-button waves-effect waves-light">Update</a>
</div>